import wixLocation from 'wix-location';

$w.onReady(function () {
	// Write your code here
});

export function input10_keyPress(event) {
	if (event.key === 'Enter') {
		if (wixLocation.path[0] === 'search') {
			wixLocation.queryParams.add({q: event.target.value})
		} else {
			wixLocation.to('/search?q=' + event.target.value)
		}
	}
}